import { isCuttingTool, useDesignerStore, type ViewMode } from "@/state/designerStore";

const VIEWS: ReadonlyArray<{ id: ViewMode; label: string; key: string; hint: string }> = [
  { id: "free", label: "3D", key: "0", hint: "Perspective view for sculpting" },
  { id: "top", label: "Top", key: "T", hint: "Plan view, looking straight down" },
  { id: "front", label: "Front", key: "F", hint: "Front elevation" },
  { id: "back", label: "Back", key: "B", hint: "Back elevation" },
  { id: "left", label: "Left", key: "L", hint: "Left elevation" },
  { id: "right", label: "Right", key: "R", hint: "Right elevation" },
];

/**
 * The standard views. Everything except "3D" is an orthographic elevation,
 * which is both what you want for judging a profile and what the Cut tool
 * needs to sweep a straight break through the block.
 */
export function ViewSwitcher(): React.ReactElement {
  const viewMode = useDesignerStore((s) => s.viewMode);
  const setViewMode = useDesignerStore((s) => s.setViewMode);
  const tool = useDesignerStore((s) => s.tool);

  return (
    <div className="panel views" role="group" aria-label="Standard views">
      {VIEWS.map((view) => {
        const disabled = isCuttingTool(tool) && view.id === "free";
        return (
          <button
            key={view.id}
            type="button"
            className="view-btn"
            aria-pressed={viewMode === view.id}
            disabled={disabled}
            title={
              disabled
                ? "Cutting needs a straight-on view — the cut follows the view direction"
                : `${view.hint} (${view.key})`
            }
            onClick={() => setViewMode(view.id)}
          >
            {view.label}
          </button>
        );
      })}
    </div>
  );
}
